import { Checkbox } from "@/shared/components/ui/checkbox";
import type { ColumnDef } from "@tanstack/react-table";
import type { ControlPanelUserRow } from "../types/controlPanelUser";

export function useControlPanelUserColumns(): ColumnDef<ControlPanelUserRow>[] {
    return [
        {
            id: "select",
            header: ({ table }) => (
                <Checkbox
                    checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && "indeterminate")}
                    onCheckedChange={(v) => table.toggleAllPageRowsSelected(!!v)}
                    aria-label="Select all"
                />
            ),
            cell: ({ row }) => (
                <Checkbox
                    checked={row.getIsSelected()}
                    onCheckedChange={(v) => row.toggleSelected(!!v)}
                    aria-label="Select row"
                    onClick={(e) => e.stopPropagation()}
                />
            ),
            size: 50,
            minSize: 50,
            maxSize: 50,
            enableSorting: false,
            enableResizing: false,
        },
        { accessorKey: "id", header: "ID" },
        { accessorKey: "userEmail", header: "유저 이메일" },
        { accessorKey: "grant", header: "권한 그룹" },
    ];
}